import React from "react";
import styled from "styled-components/macro";
import RgiApprovedHeader from "./rgiApprovedHeader";
import LenderDataHeader from "./lenderDataHeader";
import DeliverablesModule from "./deliverablesModule";
import ApprovedPreviewCalculationsSection from "./approvedPreviewCalculationSection";

const DeliverablesContainer = styled.div`
  flex: 2;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ApprovedTasks = props => {
  const taskWithAttachments = props.formikProps?.values?.tasks?.filter(task => task.files && task.files.length > 0);
  return (
    <div>
      <div style={{ padding: "1em", backgroundColor: "white" }}>
        <LenderDataHeader
          history={props.history}
          lenderData={{ deal: { name: props?.taskDetails?.deal?.name, id: props?.taskDetails?.deal?.id, borrowingEntities: props.borrowingEntities || [] } }}
          expDate={props.expirationDate}
          setExpirationDate={props.updateAuthRecord}
          authenticated={true}
          downloadReport={props.downloadReport}
          editExpiration={true}
          rgiId={props?.match?.params?.reportId}
        />
      </div>
      <RgiApprovedHeader
        canApprove={props.canApprove}
        lastSent={props?.taskDetails?.emailAuth?.lastSent}
        setAsMarkedEmail={props.setAuthAsEmail}
        setAsMarkedExternal={props.setAuthAsExternal}
        setShowEditView={props.setShowEditView}
        taskDetails={props?.taskDetails}
        submitReport={props.submitReport}
        prevPin={props?.taskDetails?.emailAuth?.authCode}
        userEmail={props?.authentication?.user?.contact?.email}
        userName={props?.authentication?.user?.contact?.fullName}
        contacts={props?.configItems?.contacts}
        company={props?.company}
        frequency={props?.taskDetails?.reportGroup?.frequency}
        rgiId={props.rgiId}
        expirationDate={props.expirationDate}
        externalShare={props?.taskDetails?.emailAuth?.externalShare}
      />
          {props.showReportCalculations && (
            <ApprovedPreviewCalculationsSection taskDetails={props.taskDetails} />
          )}
      {taskWithAttachments && taskWithAttachments.map(task => (
        <DeliverablesContainer>
          <DeliverablesModule
            width={100}
            task={task}
            ableToSeePrivilegedInfo={props.isPrivilegedUser}
            handleDownload={props.handleDownload}
            type={task.taskName}
            files={task.files || []}
          />
        </DeliverablesContainer>
        ))}
    </div>
  );
};

export default ApprovedTasks;
